<script>
    export let data =  {}
    //export let domi = {}
    if(!data.form.fichasocio){
        data.form.fichasocio.map((v,i,a) => {
            a[i].FechaNacimiento = (v.FechaNacimiento||'').substr(0,10).split('-').reverse().join('-')
            a[i].EstadoCivil = (v.EstadoCivil||'').trim()   
            a[i].Domicilio = (data.domisocio.Domicilio||'').trim()   
            a[i].Localidad = (data.domisocio.Localidad||'').trim()   
            a[i].CodPostal = (data.domisocio.CodPostal||'').trim()   
            a[i].Provincia = (data.domisocio.Provincia||'').trim()   
            a[i].Pais = (data.domisocio.Pais||'').trim()   
            a[i].Observaciones = (data.domisocio.Observaciones||'').trim()   
            a[i].Telefono = (v.TelefonoCelular||'').trim()   
            a[i].Email = (v.Email||'').trim()   
        })
    }
 

</script>

<!-- <pre>{JSON.stringify(data,null,2)}</pre> -->
<small>
{#each data.form.fichasocio as item,index}
    {#if index===0}
        
    
    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Apellido</label>
        <div class="col-sm-4">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].Apellido}>
        </div>
        <label for="" class="col-sm-2 col-form-label text-end">Nombre</label>
        <div class="col-sm-4">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].Nombre}>
        </div>
    </div>

    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Fecha Nac.</label>
        <div class="col-sm-4">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].FechaNacimiento}>
        </div>
        <label for="" class="col-sm-2 col-form-label text-end">Est. Civil</label>
        
        <div class="col-sm-4">
            <select class="form-select" bind:value={data.form.fichasocio[index].EstadoCivil} aria-label="Tipos">
                <option selected>Estado Civil</option>
                <option value="Casado">Casado</option>
                <option value="Soltero">Soltero</option>
                <option value="Divorciado">Divorciado</option>
                <option value="Viudo">Viudo</option>
                <option value="Otro">Otro</option>
            </select>
        </div>
        
    </div>

    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Sexo</label>
        <div class="col-sm-4">
            <select class="form-select" bind:value={data.form.fichasocio[index].Sexo} aria-label="Tipos">
                <option selected>Sexo</option>
                <option value="M">Masculino</option>
                <option value="F">Femenino</option>
                <option value="X">No Binario</option>
            </select>
        </div>
       
        <label for="" class="col-sm-1 col-form-label text-end">DOC</label>
        <div class="col-sm-2">
            <select class="form-select" bind:value={data.form.fichasocio[index].TipoDocumento} aria-label="Tipos">
                <option selected>Tipo Doc.</option>
                <option value="LC">LC</option>
                <option value="LE">LE</option>
                <option value="DNI">DNI</option>
                <option value="CI">CI</option>
                <option value="PASS">PASS</option>
            </select>
        </div>
        <div class="col-sm-3">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].NumeroDocumento}>
        </div>
        
    </div>


    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Ocupacion</label>
        <div class="col-sm-6">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].Ocupacion}>
        </div>
    </div>


    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Domicilio</label>
        <div class="col-sm-10">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].Domicilio}>
        </div>
    </div>

    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Localidad</label>
        <div class="col-sm-6">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].Localidad}>
        </div>
        
        <label for="" class="col-sm-2 col-form-label text-end">C. Postal</label>
        <div class="col-sm-2">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].CodPostal}>
        </div>
    </div>
    
    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Provincia</label>
        <div class="col-sm-3">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].Provincia}>
        </div>
        <label for="" class="col-sm-2 col-form-label text-end">Pais</label>
        <div class="col-sm-5">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].Pais}>
        </div>
    </div>

    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Telefono</label>
        <div class="col-sm-10">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].TelefonoCelular}>
        </div>
    </div>
    
    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Email</label>
        <div class="col-sm-10">
            <input type="text" class="form-control" bind:value={data.form.fichasocio[index].Email}>
        </div>
    </div>

    <div class="mb-2 row">
        <label for="" class="col-sm-2 col-form-label">Observaciones</label>
        <div class="col-sm-10">
            <textarea class="form-control" rows=4 bind:value={data.form.fichasocio[index].Observaciones}></textarea>
        </div>
    </div>
    
    <div class="row border-bottom my-4"></div>
    {/if}
{:else}
    AGREGAR

{/each}
</small>